import type { PaletteMode } from '@mui/material';
import type { Components, Theme } from '@mui/material/styles';

/** Shared surface for dialogs, tour cards and floating study panels. */
export const getModalSurface = (mode: PaletteMode) => ({
  backgroundColor: mode === 'dark' ? '#2d2d2d' : '#f5f5f5',
  backgroundImage: 'none',
  color: mode === 'dark' ? '#f5f5f5' : '#212121',
  border: `1px solid ${mode === 'dark' ? '#858585' : '#616161'}`,
  borderRadius: '6px',
  boxShadow:
    mode === 'dark'
      ? '0 2px 5px rgba(0,0,0,0.55), 0 1px 2px rgba(0,0,0,0.4)'
      : '0 2px 5px rgba(0,0,0,0.24), 0 1px 2px rgba(0,0,0,0.18)',
});

export const modalComponents: Components<Theme> = {
  MuiDialog: {
    styleOverrides: {
      paper: ({ theme }) => getModalSurface(theme.palette.mode),
    },
  },
  MuiPopover: {
    styleOverrides: { paper: ({ theme }) => getModalSurface(theme.palette.mode) },
  },
  MuiSnackbar: {
    styleOverrides: {
      root: ({ theme }) => ({
        '& .MuiAlert-root, & .MuiSnackbarContent-root': getModalSurface(theme.palette.mode),
      }),
    },
  },
};
